<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: id Input -->
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PLACEHOLDERS.ad_number')"
                v-model.trim="filterOptions.id"
              />
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PLACEHOLDERS.name')"
                v-model.trim="filterOptions.user_name"
              />
              <!-- End:: id Input -->
              <!-- Start:: Name Input -->
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PLACEHOLDERS.ads_name')"
                v-model.trim="filterOptions.name"
              />
              <!-- End:: Name Input -->
              <!-- Start:: Ad type Input -->

              <base-select-input
                col="3"
                :optionsList="adTypes"
                :placeholder="$t('PLACEHOLDERS.ad_type')"
                v-model="filterOptions.ad_type"
              />
              <!-- End:: Ad type  Input -->
              <!-- Start:: Ad type Input -->

              <base-select-input
                col="3"
                :optionsList="estateTypes"
                :placeholder="$t('PLACEHOLDERS.building_type')"
                v-model="filterOptions.building_type"
              />
              <!-- End:: Ad type  Input -->
              <base-select-input
                col="3"
                :optionsList="states"
                :placeholder="$t('PLACEHOLDERS.state')"
                v-model="filterOptions.state"
              />
              <!-- Start:: City type Input -->
              <base-select-input
                col="3"
                :optionsList="cities"
                :placeholder="$t('PLACEHOLDERS.city')"
                v-model="filterOptions.city"
              />
              <!-- End:: City type  Input -->
              <!-- Start:: State type Input -->
              <!-- Start:: District type Input -->

              <base-select-input
                col="3"
                :optionsList="districts"
                :placeholder="$t('PLACEHOLDERS.district')"
                v-model="filterOptions.district"
              />

              <base-select-input
                col="3"
                :optionsList="featuredTypes"
                :placeholder="$t('PLACEHOLDERS.appearance_type')"
                v-model="filterOptions.featureType"
              />

              <base-select-input
                col="3"
                :optionsList="statusTypes"
                :placeholder="$t('PLACEHOLDERS.publish_status')"
                v-model="filterOptions.is_blocked"
              />
              <!-- End:: State type  Input -->

              <base-input
                col="3"
                type="date"
                :placeholder="$t('PLACEHOLDERS.created_at')"
                v-model.trim="filterOptions.date"
              />
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.advertisement_management") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <div class="title_route_wrapper d-flex gap-2">
          <v-btn
            color="green darken-2"
            :disabled="excelLoading"
            class="excel-btn"
            @click="downloadExcel"
          >
            {{ $t("BUTTONS.downloadExcel") }}
          </v-btn>
          <v-btn
            color="green darken-2"
            :disabled="pdfLoading"
            class="pdf-btn"
            @click="downloadPdf"
          >
            {{ $t("BUTTONS.downloadPdf") }}
          </v-btn>
        </div>

        <base-input
          :label="$t('TITLES.item_per_page')"
          :placeholder="$t('TITLES.item_per_page')"
          col="5"
          type="number"
          class="my-0 base-input py-0"
          v-model="paginations.items_per_page"
        />
      </div>
      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        v-model="selected"
        item-class="ltr"
        :items-per-page="
          paginations.items_per_page === ''
            ? 10
            : Number(paginations.items_per_page)
        "
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <!-- Start:: Item ID -->
        <template v-slot:[`item.number`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>
        <!-- End:: Item ID -->

        <template v-slot:[`item.user`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item?.advertiser?.user">-</h6>
            <p v-else>
              {{ item.advertiser.user.name }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.estate_type`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item?.estate_type">-</h6>
            <p v-else>
              {{ item.estate_type.name }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.state`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item?.state">-</h6>
            <p v-else>
              {{ item.state.name }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.city`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item?.city">-</h6>
            <p v-else>
              {{ item.city.name }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.district`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item?.district">-</h6>
            <p v-else>
              {{ item.district.name }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.end_at`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item.end_at">-</h6>
            <p v-else>
              {{ item.end_at }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item?.status">-</h6>
            <p v-else>
              {{ item.trans_status }}
            </p>
          </div>
        </template>

        <!-- Start:: Title -->
        <template v-slot:[`item.name`]="{ item }">
          <p class="text-danger" v-if="!item.name">{{ $t("TABLES.noData") }}</p>
          <p v-else>{{ item.name }}</p>
        </template>
        <!-- End:: Title -->

        <template v-slot:[`item.media`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.media">
              {{ $t("TABLES.noData") }}
            </h6>
          </div>
        </template>

        <template v-slot:[`item.is_active`]="{ item }">
          <div
            class="activation"
            dir="ltr"
            style="z-index: 1"
            v-if="$can('sliders activate', 'sliders')"
          >
            <v-switch
              class="mt-2"
              color="success"
              v-model="item.is_active"
              hide-details
              @change="changeActivationStatus(item)"
            ></v-switch>
          </div>

          <template v-else>
            <span class="text-success text-h5" v-if="item.is_active">
              <i class="far fa-check"></i>
            </span>
            <span class="text-danger text-h5" v-else>
              <i class="far fa-times"></i>
            </span>
          </template>
        </template>
        <!-- End:: Activation -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip placement="bottom" v-if="$can('ads activate', 'ads')">
              <template slot="title">
                <span>{{
                  item.status !== "blocked"
                    ? $t("PLACEHOLDERS.block")
                    : $t("PLACEHOLDERS.publish")
                }}</span>
              </template>
              <button
                v-if="item.status != 'blocked'"
                class="btn_show"
                @click="selectBlockItem(item)"
              >
                <i class="fas fa-minus-circle"></i>
              </button>
              <button v-else class="btn_show" @click="selectBlockItem(item)">
                <i class="fas fa-check-double"></i>
              </button>
            </a-tooltip>
            <a-tooltip placement="bottom" v-if="$can('ads show', 'ads')">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>

            <a-tooltip
              placement="bottom"
              v-if="$can('sliders edit', 'sliders')"
              :class="{ disable_parent: item.can_edit === true }"
            >
              <template slot="title">
                <span>{{ $t("BUTTONS.edit") }}</span>
              </template>
              <button
                class="btn_edit"
                @click="editItem(item)"
                :class="{ disable_child: item.can_edit === true }"
              >
                <i class="fal fa-edit"></i>
              </button>
            </a-tooltip>

            <template v-else>
              <i
                class="fal fa-lock-alt fs-5 blue-grey--text text--darken-1"
              ></i>
            </template>
          </div>
        </template>
        <!-- End:: Actions -->

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: Image Modal -->
          <image-modal
            v-if="dialogImage"
            :type="selectedItemType"
            :modalIsOpen="dialogImage"
            :modalImage="selectedItemImage"
            @toggleModal="dialogImage = !dialogImage"
          />
          <!-- End:: Image Modal -->

          <!-- Start:: Description Modal -->
          <description-modal
            v-if="dialogDescription"
            :modalIsOpen="dialogDescription"
            :modalDesc="selectedDescriptionTextToShow"
            @toggleModal="dialogDescription = !dialogDescription"
          />
          <!-- End:: Description Modal -->

          <v-dialog v-model="dialogDelete">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToDelete">
                {{
                  $t("TITLES.DeleteConfirmingMessage", {
                    name: itemToDelete.name,
                  })
                }}
              </v-card-title>

              <v-card-title v-if="!itemToDelete" class="text-h5 justify-center">
                {{ $t("TITLES.delete_selected") }}
              </v-card-title>

              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="
                    !itemToDelete
                      ? confirmDeleteSelected()
                      : confirmDeleteItem()
                  "
                  >{{ $t("BUTTONS.ok") }}</v-btn
                >

                <v-btn class="modal_cancel_btn" @click="dialogDelete = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog @input="onDialogToggle" v-model="dialogBlock">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToBlock">
                {{
                  $t(
                    itemToBlock?.status !== "blocked"
                      ? "PLACEHOLDERS.BlockConfirmingMessage"
                      : "PLACEHOLDERS.UnblockConfirmingMessage"
                  )
                }}
              </v-card-title>

              <form class="w-100">
                <base-input
                  col="12"
                  rows="3"
                  type="textarea"
                  :placeholder="$t('PLACEHOLDERS.blockReason')"
                  v-model.trim="blockReason"
                  v-if="itemToBlock?.status !== 'blocked'"
                  required
                />
              </form>
              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  :disabled="!blockReason && itemToBlock?.status !== 'blocked'"
                  @click="confirmBlockItem()"
                  >{{ $t("BUTTONS.ok") }}</v-btn
                >

                <v-btn class="modal_cancel_btn" @click="dialogBlock = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- change status -->
          <v-dialog v-model="changeStatus">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("TITLES.chane_selected") }}
              </v-card-title>
              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="confirmChangeSelectedStatus"
                  >{{ $t("BUTTONS.ok") }}</v-btn
                >

                <v-btn class="modal_cancel_btn" @click="changeStatus = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- End:: Delete Modal -->
        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "Alladvertisements",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: false,
        },
      ];
    },
    featuredTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.distinct"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.indiscriminate"),
          value: false,
        },
      ];
    },
    statusTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.published"),
          value: false,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.blocked"),
          value: 1,
        },
      ];
    },
    adTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.for_rent"),
          value: "rent",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.for_sale"),
          value: "sale",
        },
      ];
    },
  },

  data() {
    return {
      excelLoading: false,
      blockReason: "",
      dialogBlock: false,
      excelUrl: null,
      itemToBlock: null,
      myHeaderCheck: false,
      changeStatus: false,
      selected: [],
      estateTypes: [],
      loading: false,
      isWaitingRequest: false,
      pdfLoading: false,

      filterFormIsActive: false,
      filterOptions: {
        name: null,
        ad_type: null,
        is_blocked: null,
        is_active: null,
        id: null,
        city: null,
        district: null,
        state: null,
        featureType: null,
        status: null,
        date: null,
        building_type: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.ImagesSpaces.serialNumber"),
          value: "number",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.ad_number"),
          value: "id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.ad_type"),
          value: "ad_type",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.building_type"),
          value: "estate_type",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.user"),
          value: "user",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.state"),
          value: "state",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.city"),
          value: "city",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.district"),
          value: "district",
          align: "center",
          sortable: false,
          width: "120",
        },
        {
          text: this.$t("PLACEHOLDERS.appearance_type"),
          value: "appearence_type",
          align: "center",
          sortable: false,
          width: "120",
        },
        {
          text: this.$t("PLACEHOLDERS.ad_status"),
          value: "status",
          align: "center",
          sortable: false,
          width: "120",
        },
        {
          text: this.$t("PLACEHOLDERS.created_at"),
          value: "created_at",
          align: "center",
          sortable: false,
          width: "120",
        },
        {
          text: this.$t("TABLES.Clients.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data
      states: [],
      districts: [],
      cities: [],
      allCities: [], // Store all cities
      allDistricts: [], // Store all districts
      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogDelete: false,
      itemToDelete: null,
      selectedItemType: null,
      dialogBlock: null,
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },

      // End:: Pagination Data
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.myHeaderCheck = false;
      this.selected = [];
      this.setTableRows();
    },
    "paginations.items_per_page"(newVal, oldVal) {
      this.paginations.current_page = 1;
      this.debouncedFetch();
    },
    selected(data) {
      if (data.length == 0) {
        this.myHeaderCheck = false;
      } else {
        this.myHeaderCheck = true;
      }
    },

    // Watch for state changes
    "filterOptions.state"(newState) {
      this.getCities(newState.id);
      this.filterOptions.city = null; // Reset city when state changes
    },

    // Watch for city changes
    "filterOptions.city"(newCity) {
      this.filterOptions.district = null; // Reset district when city changes
      this.getDistricts(newCity.id);
    },
  },

  methods: {
    async downloadExcel() {
      this.excelLoading = true;
      try {
        const res = await this.$axios({
          method: "GET",
          url: "/ads/generate-excel",
          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.name,
            user_name: this.filterOptions.user_name,
            ad_type: this.filterOptions.ad_type?.value,
            id: this.filterOptions.id,
            estate_type: this.filterOptions.building_type?.id,
            city: this.filterOptions.city?.id,
            state: this.filterOptions.state?.id,
            district: this.filterOptions.district?.id,
            ...(this.filterOptions.is_blocked !== null && {
              is_blocked: this.filterOptions.is_blocked.value ?? false,
            }),
            is_featured: this.filterOptions.featureType?.value,
            created_at: this.filterOptions?.date,
            limit:
              this.paginations.items_per_page === ""
                ? 10
                : Number(this.paginations.items_per_page),
          },
        });

        const excelUrl = res.data?.data?.data;

        if (excelUrl) {
          window.open(excelUrl, "_blank");
        }
      } catch (error) {
        console.error("Error downloading file:", error);
      } finally {
        this.excelLoading = false;
      }
    },
    async downloadPdf() {
      this.pdfLoading = true;
      try {
        const res = await this.$axios({
          method: "GET",
          url: "/ads/generate-pdf",
          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.name,
            user_name: this.filterOptions.user_name,
            ad_type: this.filterOptions.ad_type?.value,
            id: this.filterOptions.id,
            estate_type: this.filterOptions.building_type?.id,
            city: this.filterOptions.city?.id,
            state: this.filterOptions.state?.id,
            district: this.filterOptions.district?.id,
            ...(this.filterOptions.is_blocked !== null && {
              is_blocked: this.filterOptions.is_blocked.value || false,
            }),
            is_featured: this.filterOptions.featureType?.value,
            created_at: this.filterOptions?.date,
            limit:
              this.paginations.items_per_page === ""
                ? 10
                : Number(this.paginations.items_per_page),
          },
        });

        const pdfUrl = res.data?.data?.data;

        if (pdfUrl) {
          window.open(pdfUrl, "_blank");
        }
      } catch (error) {
        console.error("Error downloading file:", error);
      } finally {
        this.pdfLoading = false;
      }
    },
    handleHeaderClick() {
      if (this.myHeaderCheck) {
        this.selected = this.tableRows;
      } else {
        this.selected = [];
      }
    },
    async confirmDeleteSelected() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("_method", "DELETE");
      this.selected.map((item, index) => {
        REQUEST_DATA.append(`ids[${index}]`, `${item.id}`);
      });
      try {
        await this.$axios({
          method: "POST",
          url: `sliders/remove-many`,
          data: REQUEST_DATA,
        });
        this.dialogDelete = false;
        this.selected = [];
        this.myHeaderCheck = false;
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.delete_selected_successfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },

    debouncedFetch: debounce(function () {
      this.setTableRows();
    }, 500),
    // Start:: Handel Filter
    openDeleteDialogForSelected() {
      this.itemToDelete = null;
      this.dialogDelete = true;
    },

    async confirmChangeSelectedStatus() {},
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/advertisements/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.user_name = null;
      this.filterOptions.name = null;
      this.filterOptions.ad_type = null;
      this.filterOptions.id = null;
      this.filterOptions.building_type = null;
      this.filterOptions.state = null;
      this.filterOptions.city = null;
      this.filterOptions.district = null;
      this.filterOptions.status = null;
      this.filterOptions.featureType = null;
      this.filterOptions.date = null;
      this.filterOptions.is_blocked = null;

      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/advertisements/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter
    onDialogToggle() {
      this.blockReason = "";
    },
    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      console.log(this.filterOptions.is_blocked);
      try {
        let res = await this.$axios({
          method: "GET",
          url: "ads",
          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.name,
            user_name: this.filterOptions.user_name,
            ad_type: this.filterOptions.ad_type?.value,
            id: this.filterOptions.id,
            estate_type: this.filterOptions.building_type?.id,
            city: this.filterOptions.city?.id,
            state: this.filterOptions.state?.id,
            district: this.filterOptions.district?.id,
            ...(this.filterOptions.is_blocked !== null && {
              is_blocked: this.filterOptions.is_blocked?.value ?? false,
            }),
            is_featured: this.filterOptions.featureType?.value,
            created_at: this.filterOptions?.date,
            limit:
              this.paginations.items_per_page === ""
                ? 10
                : Number(this.paginations.items_per_page),
          },
        });
        this.loading = false;
        this.tableRows = res.data.data;
        this.paginations.last_page = res.data.meta.last_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    showDescriptionModal(description) {
      this.dialogDescription = true;
      this.selectedDescriptionTextToShow = description;
    },

    async changeActivationStatus(item) {
      try {
        await this.$axios({
          method: "POST",
          url: `sliders/activate/${item.id}`,
        });
        this.$message.success(this.$t("MESSAGES.changeActivation"));
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },

    editItem(item) {
      this.$router.push({ path: `/advertisements/edit/${item.id}` });
    },

    showItem(item) {
      this.$router.push({ path: `/advertisements/show/${item.id}` });
    },
    // ===== End:: End

    showImageModal(item) {
      this.dialogImage = true;
      this.selectedItemImage = item.media;
      const videoExtensions = [
        "mp4",
        "mov",
        "avi",
        "wmv",
        "flv",
        "mkv",
        "webm",
        "m4v",
      ];
      const fileExtension = item.media.split(".").pop().toLowerCase();
      this.selectedItemType = videoExtensions.includes(fileExtension)
        ? "video"
        : "image";
    },

    // ===== Start:: Delete
    selectDeleteItem(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },
    selectBlockItem(item) {
      this.dialogBlock = true;
      this.itemToBlock = item;
    },
    async confirmDeleteItem() {
      try {
        await this.$axios({
          method: "DELETE",
          url: `sliders/${this.itemToDelete.id}`,
        });
        this.dialogDelete = false;
        this.tableRows = this.tableRows.filter((item) => {
          return item.id != this.itemToDelete.id;
        });
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },
    async confirmBlockItem() {
      try {
        const REQUEST_DATA = new FormData();
        console.log("reason", this.blockReason);
        console.log("item", this.itemToBlock);

        REQUEST_DATA.append("reason", this.blockReason ?? "");

        await this.$axios({
          method: "POST",
          url: `ads/${
            this.itemToBlock.status == "blocked" ? "publish" : "block"
          }/${this.itemToBlock.id}`,
          data: REQUEST_DATA,
        });
        this.dialogBlock = false;
        this.blockReason = "";

        this.$message.success(
          this.itemToBlock?.is_blocked
            ? this.$t("PLACEHOLDERS.publishedSuccessfully")
            : this.$t("PLACEHOLDERS.blockedSuccessfully")
        );
        this.setTableRows();
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },
    async getEstateTypes() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `estate-types?page=0&limit=0&status=1&ignorePermissionCheck=1`,
        });
        this.estateTypes = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getCities(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities?page=0&limit=0&status=1&state=${id}&ignorePermissionCheck=1`,
        });
        this.allCities = res.data.data;
        this.cities = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getDistricts(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `districts?page=0&limit=0&status=1&city=${id}&ignorePermissionCheck=1`,
        });
        this.allDistricts = res.data.data;
        this.districts = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getStates() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `states?page=0&limit=0&status=1&ignorePermissionCheck=1`,
        });
        console.log("states", res.data.data);
        this.states = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // ===== End:: Delete

    // ==================== End:: Crud ====================
  },

  created() {
    // Start:: Fire Methods
    this.getEstateTypes();
    this.getStates();

    this.getEstateTypes();
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }

    // Check if is_blocked filter is in URL query params
    if (this.$route.query.is_blocked !== undefined) {
      const isBlockedValue =
        this.$route.query.is_blocked === "false" ? false : true;
      this.filterOptions.is_blocked = this.statusTypes.find(
        (status) => status.value === isBlockedValue
      );
    }

    this.setTableRows();

    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.disable_parent {
  cursor: no-drop !important;
}

.disable_child {
  opacity: 0.5;
  pointer-events: none !important;
}
.excel-btn,
.pdf-btn {
  color: white !important;
}
</style>
